import {api} from '../maps/data.js';
import {permissionsMap} from "../maps/permissionsMap";

export const saveTokens = tokens => {
    window.localStorage.setItem('accessToken', tokens.accessToken);
    window.localStorage.setItem('refreshToken', tokens.refreshToken);
};

export const getCurrentAccountType = () => {
    const typeFromLocalStorage = window.localStorage.getItem('accountType');
    return typeFromLocalStorage || 'SHOPPER';
};

export const setCurrentAccountType = (accountType) => {
    window.localStorage.setItem('accountType', accountType);
};

const removeTokens = () => {
    window.localStorage.removeItem('accessToken');
    window.localStorage.removeItem('refreshToken');
};

export const getToken = type => {
    return window.localStorage.getItem(type);
};

export const getCurrent = async () => {
    const user = await api({
        type: 'getCurrent',
        disableEH: true
    });
    if (!!user) {
        zibi.set_user(user);
        zibi.set_isLoggedIn(true);
    }
    return user;
};

export const getCurrentShopper = async () => {
    const shopper = await api({
        type: 'getCurrentShopper',
        disableEH: true
    });
    if (!!shopper) {
        zibi.set_shopper(shopper);
        zibi.set_isLoggedIn(true);
    }
    return shopper;
};

export const setLogin = async (tokens, callback, isShopper = false) => {
    saveTokens(tokens);
    setCurrentAccountType(isShopper ? "SHOPPER" : "USER");
    const user = isShopper ? await getCurrentShopper() : await getCurrent();

    let userRole = user.role?.[0];
    let defaultRoute = '/';

    if (isShopper) {
        userRole = "SHOPPER";
        if (!user.name) {
            defaultRoute = '/profile';
            userRole = undefined;
        }
    }

    if (userRole) {
        defaultRoute = permissionsMap[userRole].defaultRoute;
    }
    callback(defaultRoute);
};

export const logout = () => {
    removeTokens();
    zibi.set_user(null);
    zibi.set_shopper(null);
    zibi.set_isLoggedIn(false);
};